type Args = {
  minutesInterval: number;
  start: number;
  end: number;
};
export const generateTimeArray = ({ minutesInterval = 30, start = 10, end = 18 }: Args) => {
  const times: string[] = [];
  let currentItem = start * 60;
  const ampm = ['AM', 'PM'];

  for (let i = 0; currentItem <= end * 60; i++) {
    const hh = Math.floor(currentItem / 60);
    const mm = currentItem % 60;
    times[i] = `${`${hh == 12 ? 12 : hh % 12}`.slice(-2)}:${`0${mm}`.slice(-2)} ${ampm[Math.floor(hh / 12)]}`;
    currentItem = currentItem + minutesInterval;
  }

  return times;
};
